<template>
    <div class="group">
        <div class="bg-blue-light w-full rounded-8 p-16">
            <div class="flex items-center mb-10">
                <img :src="insight.user.avatar || `/images/placeholders/avatar.png`" :alt="insight.user.full_name" class="w-40 h-40 mr-8 rounded-full border border-blue-light">
                <p class="leading-tight">
                    <strong>{{ insight.user.full_name }}</strong><br>
                    <template v-if="insight.user.position">
                        {{ insight.user.position }},
                    </template>
                    {{ client.name }}
                </p>
            </div>
            <p>
                <span v-html="text"></span>
                <span v-if="hasReadMore" @click="showMore = !showMore">
                    <span v-if="!showMore">
                        &hellip;
                        <strong>Read more</strong>
                    </span>
                    <strong v-else>Read less</strong>
                </span>
            </p>
        </div>
        <div class="w-full flex justify-end mb-16 mt-2">
            <a v-if="canDelete" @click="onDelete" class="text-coral mr-10 items-center hidden group-hover:flex cursor-pointer">
                <svg class="w-14 h-14 fill-coral mr-4 -mt-2" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"/></svg>
                <span>Delete</span>
            </a>
            <span class="text-blue-lightest">{{ insightDate }}</span>
        </div>
    </div>
</template>

<script>
    import { format, parseISO } from "date-fns"
    import { get } from 'vuex-pathify'

    export default {
        props: {
            insight: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                showMore: false,
                readMoreLimit: 20,
            }
        },

        computed: {
            user: get('auth/user'),

            canDelete() {
                return this.insight.user.id === this.user.id
            },

            client() {
                return this.insight.user.default_client
            },

            insightDate() {
                return format(parseISO(this.insight.created_at), 'dd MMM yyyy')
            },

            hasReadMore() {
                return this.textCount > this.readMoreLimit ? true : false
            },

            text() {
                if (this.showMore) {
                    return this.insight.text
                }

                return this.splitText(this.insight.text, this.readMoreLimit)
            },

            textCount() {
                return this.insight.text.split(' ').length
            }
        },

        methods: {
            onDelete() {
                this.$emit('delete', this.insight)
            },

            splitText(text, limit) {
                const textArray = text.split(' ')

                if (textArray.length > limit) {
                    return textArray.slice(0, limit).join(' ')
                }

                return text;
            },
        }
    }
</script>